import "./Servisi.scss";
import dots from "../../../components/img/Group 70.svg";
import { LazyMotion, domAnimation, m } from "framer-motion";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";
function Servisi() {
  return (
    <section id="servisi">
      <div>
        <h1>Šta ti je potrebno?</h1>
        <div id="bckBox"></div>
      </div>
      <LazyMotion features={domAnimation} strict>
        <m.div
          className="box"
          transition={{}}
          initial={{ x: 200 }}
          whileInView={{ x: 0 }}
        >
          <a href="/kalkulator.html">
            <div className="Srv" id="PrijaviStetu">
              <div></div>
              <strong>Kalkulator poena</strong>
              <p>za upis u I razred srednje stručne škole</p>
            </div>
          </a>
          <a href={/*Config.lmsUrl*/ "https://elektropg.online/ets/"}>
            <div className="Srv" id="Lms">
              <div></div>
              <strong>Moodle</strong>
              <p>Platforma za učenje</p>
            </div>
          </a>
          <a href="https://elektropg.online/ets/course/index.php?categoryid=170">
            <div className="Srv" id="Obavjestenja">
              <div></div>
              <strong>Obavještenja</strong>
              <p>Budi obavješten o svemu</p>
            </div>
          </a>

         
          <a href="https://elektropg.online/ets/course/index.php?categoryid=169">
            <div className="Srv" id="">
              <div>
<FontAwesomeIcon icon={faFile} size="6x"  />
              </div>
              <br/>
              <strong>  Dokumenta</strong>
              {/* <p>Pobijedi sebe i reci zašto ćutiš</p> */}
            </div>
          </a>
        </m.div>
      </LazyMotion>
      <div id="grayBox"></div>
    </section>
  );
}
export default Servisi;
